import React, { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { authApi } from '../services/apiService';

const VerifyEmail: React.FC = () => {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading');
  const [message, setMessage] = useState('');

  useEffect(() => {
    const token = searchParams.get('token');
    if (!token) {
      setStatus('error');
      setMessage('Missing verification token.');
      return;
    }

    authApi.verifyEmail(token)
      .then((data) => {
        setStatus('success');
        setMessage(data.message);
      })
      .catch((err) => {
        setStatus('error');
        setMessage(err.message);
      });
  }, [searchParams]);

  return (
    <div style={containerStyle}>
      <div style={cardStyle}>
        <h1 style={titleStyle}>Email Verification</h1>
        {status === 'loading' && <p style={textStyle}>Verifying your email...</p>}
        {status === 'success' && (
          <>
            <p style={textStyle}>{message}</p>
            <p style={textStyle}>You can now sign in to your account.</p>
            <Link to="/" style={linkStyle}>Go to Home</Link>
          </>
        )}
        {status === 'error' && (
          <>
            <p style={{ ...textStyle, color: '#ff6b6b' }}>{message}</p>
            <Link to="/" style={linkStyle}>Go to Home</Link>
          </>
        )}
      </div>
    </div>
  );
};

const containerStyle: React.CSSProperties = {
  display: 'flex', alignItems: 'center', justifyContent: 'center',
  minHeight: '80vh', width: '100%', boxSizing: 'border-box',
  padding: '2rem 1rem',
};

const cardStyle: React.CSSProperties = {
  borderRadius: '16px', padding: '3rem',
  textAlign: 'center', maxWidth: '400px', width: '100%',
};

const titleStyle: React.CSSProperties = {
  color: '#815353', marginBottom: '1.5rem', fontSize: '1.8rem',
};

const textStyle: React.CSSProperties = { color: '#b08a8a', marginBottom: '1rem' };

const linkStyle: React.CSSProperties = {
  color: '#b08a8a', textDecoration: 'underline', fontSize: '1.1rem',
};

export default VerifyEmail;
